import { createReducer, on } from "@ngrx/store";
import { TutorEditState, initialTutorEditState } from "./tutor-edit.state";
import { GetIfAllowedToEditTutor, GetIfAllowedToEditTutorError, GetIfAllowedToEditTutorSuccess, IsTutorProfileStored, LoadTutorProfileSuccess, ResetCheckIfAllowedToEditTutor, ResetTutorUpdateProps, SetTutorProfile, UpdateTutor, UpdateTutorError, UpdateTutorSuccess } from "./tutor-edit.actions";

export const TutorEditReducers = createReducer(
  initialTutorEditState,
  on(SetTutorProfile, (state, action): TutorEditState => {
    return {
      ...state,
      tutorProfile: action.tutorProfile,
    };
  }),
  on(IsTutorProfileStored, (state, action): TutorEditState => {
    return {
      ...state,
      isTutorProfileStored: action.isTutorStored
    };
  }),
  on(LoadTutorProfileSuccess, (state, action): TutorEditState => {
    return {
      ...state,
      userProfile: action.userProfile
    };
  }),
  on(GetIfAllowedToEditTutor, (state): TutorEditState => {
    return {
      ...state,
      isAllowedToEditTutor: null,
      isAllowedToEditTutorLoader: true,
      isAllowedToEditTutorError: null,
    };
  }),
  on(GetIfAllowedToEditTutorSuccess, (state, action): TutorEditState => {
    return {
      ...state,
      isAllowedToEditTutor: action.result,
      isAllowedToEditTutorLoader: false,
      isAllowedToEditTutorError: null,
    };
  }),
  on(GetIfAllowedToEditTutorError, (state, action): TutorEditState => {
    return {
      ...state,
      isAllowedToEditTutor: null,
      isAllowedToEditTutorLoader: false,
      isAllowedToEditTutorError: action.error,
    };
  }),
  on(ResetCheckIfAllowedToEditTutor, (state): TutorEditState => {
    return {
      ...state,
      isAllowedToEditTutor: null,
      isAllowedToEditTutorLoader: false,
      isAllowedToEditTutorError: null,
    };
  }),
  on(UpdateTutor, (state): TutorEditState => {
    return {
      ...state,
      updateTutorResult: null,
      updateTutorLoader: true,
      updateTutorError: null,
    };
  }),
  on(UpdateTutorSuccess, (state, action): TutorEditState => {
    return {
      ...state,
      updateTutorResult: action.result,
      updateTutorLoader: false,
      updateTutorError: null,
    };
  }),
  on(UpdateTutorError, (state, action): TutorEditState => {
    return {
      ...state,
      updateTutorLoader: false,
      updateTutorError: action.updateTutorError,
    };
  }),
  on(ResetTutorUpdateProps, (state): TutorEditState => {
    return {
      ...state,
      updateTutorResult: null,
      updateTutorLoader: false,
      updateTutorError: null,
    };
  }),
)